import http from './http'
const api = {
    /******common*****/
    getAliParams() {
        return http('common/oss/web-oss', {}, 'get');
    },
    getOssUrl(data) {
        return http('common/oss/oss-url', data, 'get');
    },
    /******页面访问上报*****/
    pagePush(data) {
        return http('push/request', data, 'get');
    },
    /******oa******/
    //用户
    login(data) { //登录
        return http('login/getToken', data, 'post');
    },
    getUserInfo(data) { //获取用户信息
        return http('login/getUserInfo', data, 'get');
    },
    refreshToken(data) { //刷新token
        return http('login/refreshToken', data, 'get');
    },
    syncUser(data) { //同步飞书用户
        return http('user/syncUser', data, 'get');
    },
    getUser(data) { //查询用户
        return http('user/getUser', data, 'post');
    },
    updateUser(data) { //修改用户
        return http('user/updateUser', data, 'post');
    },
    delUser(data) { //删除用户
        return http('user/delete', data, 'post');
    },
    addRole(data) { //添加角色
        return http('role/addRole', data, 'post');
    },
    getRole(data) { //查询角色
        return http('role/getRole', data, 'post');
    },
    updateRole(data) { //修改角色
        return http('role/updateRole', data, 'post');
    },
    delRole(data) { //删除角色
        return http('role/delete', data, 'post');
    },
    getPermission(data) { //获取权限列表
        return http('permission/role', data, 'get');
        // return http('role/permission', data, 'get');
    },
    updatePermission(data) { //保存权限列表
        return http('permission/save', data, 'post');
    },
    updatePermissionFile(data) { //更新权限json文件
        return http('permission/init', data, 'post');
    },
    //faq
    getProductCate(data) { //获取产品类目
        return http('category/getProductCate', data, 'get');
    },
    createProductCate(data) { //创建产品类目
        return http('category/createProductCate', data, 'post');
    },
    updateProductCate(data) { //修改产品类目
        return http('category/updateProductCate', data, 'post');
    },
    tryDelProductCate(data) { //删除产品类目确认
        return http('category/tryDelProductCate', data, 'post');
    },
    deleteProductCate(data) { //删除产品类目
        return http('category/deleteProductCate', data, 'post');
    },
    getCate(data) { //获取问题类目
        return http('category/getCate', data, 'post');
    },
    createCate(data) {
        return http('category/createCate', data, 'post');
    },
    updateCate(data) {
        return http('category/updateCate', data, 'post');
    },
    tryDelCate(data) {
        return http('category/tryDelCate', data, 'post');
    },
    deleteCate(data) {
        return http('category/deleteCate', data, 'post');
    },
    getProblem(data) { //获取问题列表
        return http('category/getProblem', data, 'post');
    },
    createProblem(data) {
        return http('category/createProblem', data, 'post');
    },
    updateProblem(data) {
        return http('category/updateProblem', data, 'post');
    },
    deleteProblem(data) {
        return http('category/deleteProblem', data, 'post');
    },
    //工单
    getWorkNum(data) { //获取菜单数据
        return http('work/workNum', data, 'post');
    },
    getCreateWorkNum(data) { //获取菜单数据
        return http('work/work-total', data, 'post');
    },
    getWorkList(data) { // 工单列表
        return http('work/workInfo', data, 'post');
    },
    createWork(data) { // 创建工单
        return http('work/createWork', data, 'post');
    },
    getWorkSource(data) { // 获取工单来源
        return http('work/workSource', data, 'get');
    },
    getCountry(data) { //获取国家地区数据
        return http('work/getCountry', data, 'post');
    },
    getWorkLog(data) { //工单记录
        return http('work/workLog', data, 'post');
    },
    updateWorkInfo(data) {  //修改工单信息
        return http('work/saveWorkInfo', data, 'post');
    },
    deleteWork(data) {  //修改工单信息
        return http('work/deleteWork', data, 'post');
    },
    downloadFile(data) { //下载导入模板文件
        return http('work/downloadFile', data, 'get', 'blob');
    },
    orderExport(data) { //下载导入模板文件
        return http('work/exportWorkInfo', data, 'post', 'blob');
    },
    getWorkProblem(data) { //责任方/型号占比
        return http('over_view/workAndProblem', data, 'post');
    },
    getOrderNumber(data) { //新建/完结工单数据
        return http('over_view/createAndEnd', data, 'post');
    },
    getWorkTimer(data) { //处理耗时统计
        return http('over_view/timeInfo', data, 'post');
    },
    delWorkOrder(data) { //处理耗时统计
        return http('over_view/delete', data, 'post');
    },
    timeInfoExport(data) {  //导出
        return http('over_view/timeInfoExport', data, 'post', 'blob');
    },
	rmUnread(data) {  //工单未读
        return http('work/rmUnread', data, 'post');
    },
 	getCreaterCount(data) { //工单创建人统计
        return http('over_view/workAndCreater', data, 'post');
    },
    bindOrder(data) {  //关联工单
        return http('work/linkWork', data, 'post');
    },
    getRemindRules(data) { //获取超时提醒列表
        return http('get/workTimeoutRules', data, 'get');
    },
    addRemindRules(data) { //添加超时提醒
        return http('set/workTimeoutRules', data, 'post');
    },
    cancelBindOrder(data) {  //取消关联工单
        return http('work/rmLinkWork', data, 'post');
    },
    getBindOrder(data){  //查询关联工单列表
        return http('work/getLinkWork', data, 'post');
    },
    tryReminder(data){  //查询是否可以催单
        return http('work/tryReminder', data, 'get');
    },
    getSellChannel(data) {
        return http('work/sellChannel', data, 'get');
    },
    orderListRule(data) {
        return http('work/saveWordRule', data, 'post');
    },

    //app模块
    // 消息推送模块
    // 获取消息列表
    getMsgList(data) {
        return http('push/msg/list', data, 'get');
    },
    // 新增推送消息
    pushMsg(data) {
        return http('push/msg', data, 'post');
    },
    // 用户反馈模块
    getFbList(data) { // 获取反馈列表
        return http('app/list', data, 'get');
    },
    delFeedback(data) { // 删除问题反馈
        return http('app/delete', data, 'post');
    },
    // 更新反馈记录
    updateFb(data) {
        return http('app/update', data, 'post');
    },
    // 获取对话列表
    getFbContentList(data) {
        return http('app/content/list', data, 'get');
    },
    // 客服发送对话
    addFbContent(data) {
        return http('app/content', data, 'post');
    },
    // 工单转图片
    getFbFiles(data) {
        return http('app/firstFile', data, 'get');
    },
	//app banner图
    getBannerList(data) { //获取app banner图
        return http('app/banner-get', data, 'get'); 
    },
    updateBanner(data) { //新增/修改 app banner图
        return http('app/banner-update', data, 'post'); 
    },
    delBanner(data) { //删除 app banner图
        return http('app/banner-del', data, 'post'); 
    },    getPushList(data) { //获取推送列表
        return http('app/push-get', data, 'get');
    },
    updatePush(data) {  //新增推送、修改
        return http('app/push-update', data, 'post');
    },
    delPush(data) {  //删除推送
        return http('app/push-del', data, 'post');
    },
    getGroupList(data) { //获取群组列表
        return http('app/group-get', data, 'get');
    },
    updateGroup(data) { //更新群组列表
        return http('app/group-update', data, 'post');
    },    
    getProductVersion(data){// 查询产品版本号
        return http('app/product-version', data, 'get');
    },
    //商城配置
    getAppMallList(data) {
        return http('app/shopping/config', data, 'get');
    },
    updateAppMall(data) {
        return http('app/shopping/config/upsert', data, 'post');
    },
    //app升级配置
    appUpdateSettings(data) {
        return http('upgrade/upsert', data, 'post');
    },
    getAppUpdateSettings(data) {
        return http('upgrade/list', data, 'get');
    },
    delAppUpdateSettings(data) {
        return http('upgrade/delete', data, 'post');
    },
    //社区管理
    getCommunityTags(data) {
        return http('app/content/tag', data, 'get');
    },
    communityTagsUpdate(data) {
        return http('app/content/tag', data, 'post');
    },
    getCommunityList(data) {
        return http('app/content', data, 'get');
    },
    communityUpdate(data) {
        return http('app/content/upsert', data, 'post');
    },
    communityStatusUpdate(data) {
        return http('app/content/operate', data, 'post');
    },

    //统计模块
    /* app */
    getAppData(data) {  //获取app数据
        return http('app_view/getData', data, 'post');
    },
    getUserRegion(data) {  //获取app用户分布数据
        return http('app_view/userRegion', data, 'post');
    },
    getUserRegionActive(data) { //获取app 活跃用户分布数据
        return http('app_view/userRegionActive', data, 'get');
    },
    getAppTrend(data) {  //获取app 历史趋势数据
        return http('app_view/getDataDetail', data, 'post');
    },
    getMultiBindUserList(data) {  //获取绑定多设备用户列表（待后端接口确认路径）
        return http('app_view/multiBindUserList', data, 'post');
    },
    multiBindUserExport(data) {  //导出绑定多设备用户列表
        return http('app_view/multiBindUserExport', data, 'post', 'blob');
    },
    /* 设备统计 */
    getDeviceData(data) {  //获取设备数据
        return http('device_view_new/getData', data, 'post');
    },
    getDeviceTrend(data) {  //获取设备历史趋势数据
        return http('device_view_new/getDataDetail', data, 'post');
    },
    getDeviceFailure(data) {  //获取设备故障码
        return http('device_view/getCode', data, 'post');
    },
    getDeviceGeo(data) {  //获取设备区域分布数据
        return http('device_view/device-region', data, 'get');
    },
    getDeviceClean(data) {  //获取设备清扫分析数据
        return http('device_view/device-clean', data, 'get');
    },
    /* 销售统计 */
    getDictData(data) { //下拉值原始数据查询
        return http('sale/dictData', data, 'get');
    },
    getParamList(data) { //下拉值查询
        return http('sale/getParamList', data, 'post', 'json', 'noloading');
    },
    getSaleOverview(data) { //销售运营报表总览查询
        return http('sale/overview', data, 'post');
    },
    getOverviewTrend(data) { //销售运营报表总览历史趋势
        return http('sale/overviewHistory', data, 'post');
    },
    getTarget(data) {  //业绩报表
        return http('sale/target', data, 'post');
    },
    getTargetParam(data) {  //业绩报表
        return http('sale/targetParam', data, 'post');
    },
    getDeviceLife(data) {  //设备生命周期
        return http('device_view/device-life', data, 'get');
    },
   
    // iot模块
    getIotUserList(data) {  //获取iot用户列表
        return http('iotuser/list', data, 'get');
    },
    createUser(data) {  //创建用户
        return http('iotuser/register', data, 'post');
    },
    updateUserPwd(data) {  //更新用户密码
        return http('iotuser/update/password', data, 'post');
    },
    delUser(data) {  //注销用户
        return http('iotuser/cancel', data, 'post');
    },
    getIotUserInfo(data) {  //获取iot用户详情信息
        return http('iotuser/detail', data, 'get');
    },
    getIotUserLoginInfo(data) {  //获取iot用户登录信息
        return http('iotuser/login', data, 'get');
    },
    getIotUserDeviceInfo(data) {  //获取iot用户登录信息
        return http('iotuser/deviceByUser', data, 'get');
    },
    getUserByAccount(data) {  //获取iot用户aliUserId与region
        return http('iotuser/userByAccount', data, 'get');
    },
    deviceUnbound(data) {  //解绑设备
        return http('iotuser/delBind', data, 'get');
    },
    getUserThirdInfo(data) {  //获取用户三方信息
        return http('user/third/info', data, 'get');
    },
    getIotDeviceList(data) {  //获取设备列表
        return http('iotdevice/deviceList', data, 'post');
    },
    getdeviceAllNum(data) {  //获取设备总数
        return http('iotdevice/deviceAllNum', data, 'post','noloading');
    },
    getIotProductList(data) {  //获取产品列表
        return http('iotdevice/productList', data, 'get');
    },
    getIotDeviceDetail(data) {  //获取设备详情
        return http('iotdevice/detail', data, 'post');
    },
    getIotDeviceActive(data) {  //获取设备动态信息
        return http('iotdevice/timeLine', data, 'post');
    },
    getIotDeviceBind(data) {  //获取设备绑定信息  -- 旧
        return http('iotdevice/deviceUser', data, 'post');
    },
    getIotDeviceBindUser(data) {  //获取设备绑定信息   新
        return http('iotdevice/userInfo', data, 'get');
    },
    getIotDeviceMsg(data) {  //获取设备消息
        return http('iotdevice/msg/task', data, 'get');
    },
    getIotMarkList(data) {  //获取标识符列表
        return http('iotdevice/markList', data, 'post');
    },
    initDeviceNetwork(data) {  //重置设备网络
        return http('iotdevice/updateBaseurl', data, 'post');
    },
    getDeviceLog(data) { //获取设备记录列表
        return http('iotdevice/deviceRecord', data, 'get');
    },
    getCatData(data) { //获取猫咪数据
        return http('iotdevice/cat/data', data, 'get');
    },
    iotDeviceDoorHandle(data) { //获取猫咪数据
        return http('iotdevice/service/invoke', data, 'post');
    },

    // 销售模块
    getSalesCountList(data) {  //销售统计
        return http('sale/saleStatistics', data, 'post');
    },
    getSalesProduct(data) {  //获取销售产品
        return http('sale/dictData', data, 'get');
    },
    getSalesDetail(data) {  //获取销售明细
        return http('sale/saleDetail', data, 'post');
    },
    exportSalesCount(data) {  //导出销售统计报表
        return http('sale/saleStatisticsExport', data, 'post', 'blob');
    },
    exportSalesDetail(data) {  //导出销售统计明细
        return http('sale/saleDetailExport', data, 'post', 'blob');
    },
    exportSalesOrder(data) {  //导出销售统计订单
        return http('sale/orderDetailExport', data, 'post', 'blob');
    },
    getSkuParamList(data){  //获取sku匹配参数列表
        return http('sale/skuMatch/paramList', data, 'get');
    },
    getSkuList(data){  //获取sku人员配置列表
        return http('sale/skuMatch/list', data, 'get');
    },
    dealSkuPair(data){  //修改sku配对
        return http('sale/skuMatch/deal', data, 'post');
    },
    getSkuPairLog(data){  //获取sku配对记录
        return http('sale/skuMatch/history/list', data, 'get');
    },

    //产品模块
    getProductRegisterList(data){ //获取产品注册记录
        return http('product/registration', data, 'get');
    },
    getRegisProductCountry(data) { //查询注册用户国家信息
        return http('product/regis-country', data, 'get');
    },
    getRegisProductType(data) { //查询注册产品型号
        return http('product/regis-type', data, 'get');
    },
    getProductChannel(data) { //查询产品购买渠道
        return http('product/regis-chan', data, 'get');
    },
    getSnList(data) { //查询sn数据
        return http('product/sn', data, 'get');
    },
    getSnProductType(data) { //查询sn号产品型号
        return http('product/sn-type', data, 'get');
    },
    downloadSnFile(data) { //下载导入模板文件
        return http('product/sn-template', data, 'get', 'blob');
    },
    snExport(data) { //导入sn文件
        return http('product/sn-import', data, 'post', 'blob');
    },
    getProductType(data) { //查询产品型号
        return http('product/model-type', data, 'get');
    },
    getProductInfo(data) {  //获取产品信息
        return http('product/model', data, 'get');
    },
    uploadProductInfo(data) {  //上传产品信息
        return http('product/model', data, 'post');
    },
    
    //猫砂卡
    createClcCode(data) {  //生成猫砂卡激活码
        return http('mao/cart/create', data, 'post');
    },
    createClcOrder(data) {  //生成猫砂卡订单
        return http('mao/cart/createAndpush', data, 'post');
    },
    getClcCode(data) {  //查询猫砂卡激活码列表
        return http('mao/cart/list', data, 'get');
    },
    pushClcCode(data) {  //发放激活码
        return http('mao/cart/push', data, 'post');
    },
    updateClcCode(data) {  //编辑激活码
        return http('mao/cart/update', data, 'post');
    },
    updateClcCycle(data) {  //编辑周期兑
        return http('mao/cycle/update', data, 'post');
    },
    delClcCode(data) {  //作废激活码
        return http('mao/cart/delete', data, 'post');
    },
    getClcOrderList(data) {  //查询订单
        return http('mao/redeem/list', data, 'get');
    },
    exportClcOrderList(data) {  //导出订单
        return http('mao/redeem/export', data, 'post');
    },
    cancelClcOrder(data) {  //取消订单
        return http('mao/redeem/cancel', data, 'post');
    },

    //以旧换新活动
    getRenewList(data) { //查询订单列表
        return http('oldWithNew/oplist', data, 'get');
    },
    updateRenewOrder(data) {  // 编辑订单
        return http('oldWithNew/opupdate', data, 'post');
    },
    exportRenewOrderList(data) {  //导出订单
        return http('oldWithNew/opexport', data, 'get');
    },

    //产测模块
    ptAccount(data) { //产测工具账号新增
        return http('tool/login_config', data, 'post');
    },
    ptAccountUpdate(data) { //产测工具账号新增
        return http('tool/login_config_update', data, 'post');
    },
    ptAccountList(data) { //产测工具账号列表
        return http('tool/login_config', data, 'get');
    },
    ptGetCatBoxList(data) { //猫砂盆产测sn列表
        return http('tool/sn', data, 'get');
    },
    ptGetCatBoxNumber(data) { //猫砂盆产测sn列表
        return http('tool/sn-count', data, 'get');
    },
    ptExportSn(data) { //猫砂盆产测sn列表导出
        return http('tool/sn_export_m1', data, 'post', 'blob');
    },
    ptExportM1Log(data) { //猫砂盆产测记录导出
        return http('tool/logs/m1/export', data, 'get', 'blob');
    },
    ptUploadCatBoxState(data) { //修改猫砂盆产测sn状态
        return http('tool/sn', data, 'post');
    },
    getCatBoxSw(data) { //获取猫砂盆固件版本
        return http('tool/pcba', data, 'get');
    },
    setCatBoxSw(data) { //设置猫砂盆固件版本
        return http('tool/pcba/upsert', data, 'post');
    },
    ptAddS1Sn(data) { //新增s1产测sn配置
        return http('tool/sn_config', data, 'post');
    },
    ptExportS1Sn(data) { //导出s1产测sn
        return http('tool/sn_export', data, 'post', 'blob');
    },
    ptGetS1Setting(data) { //查询s1产测配置列表
        return http('tool/setting', data, 'get');
    },
    ptAddS1Setting(data) { //编辑s1产测新增
        return http('tool/setting', data, 'post');
    },
    ptUpdateS1Setting(data) { //编辑s1产测新增
        return http('tool/setting_update', data, 'post');
    },
    ptGetWeightSetting(data) { //查询称重配置列表
        return http('tool/weight/conf/list', data, 'get');
    },
    ptWeightSetting(data) { //编辑称重配置
        return http('tool/weight/conf', data, 'post');
    },
    ptGetWeightLog(data) { //查询称重记录
        return http('tool/weight/list', data, 'get');
    },
    ptGetWeightLogExport(data) { //导出称重记录
        return http('tool/weight/export', data, 'get');
    },
}

export default api;


// WEBPACK FOOTER //
// ./src/axios/api.js